




































































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from "../../api/ApiClient";
import moment from "moment";
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow
} from "@/utils/formHelper";
import TickCross from "@/components/TickCross.vue";
import Enumerable from 'linq';
import JsonEditor from "@/components/JsonEditor.vue";

@Component({
  components: {
    TickCross,
    JsonEditor,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  // form
  public get rules() {
    return {
      name: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
    };
  }

  public get formTitle() {
    switch (this.formState) {
      case "create":
        return this.$t('global["Create"]');
      case "edit":
        return this.$t('global["Edit"]');
      default:
        return "";
    }
  }
  public formState: string = "create";

  public form: any = {};
  public formJsonEditorValue: any = null;
  public selectedServiceTypeSms: any[] = [];
  public servicesRegions: any = {};

  public vendorSmsServicesReduce(vendor: any) {
    if (!vendor.vendorSmsServices.length) {
      return [];
    }

    const tagColors = {
      1: '',
      2: 'success',
      3: 'info',
      4: 'danger',
      5: 'warning',
    };

    return Enumerable.from(vendor.vendorSmsServices as any[])
      .orderBy(p => p.serviceTypeSms.name)
      .select(p => ({
        text: `${p.serviceTypeSms.name} -> ${p.region.name}`,
        color: tagColors[p.serviceTypeSms.id],
      }))
      .toArray();
  }

  // table
  public currentPage = 1;
  public pageSize = 100;
  public count = 1;

  public formVisible = false;
  public isTableLoading = false;
  public data: any[] = [];
  public regions: any[] = [];
  public services: any[] = [];
  public get serviceTypeSmss() {
    // TODO ts 3.7
    const service = this.services.find(p => p.name === 'Sms') || {};
    return service.serviceTypeSmss;
  }

  public mounted() {
    this.init();
  }

  // form
  public async onEditClick(row: any) {
    const form = { ...row };
    try {
      form.value = JSON.parse(row.value);
    } catch(e) {

    }

    this.formJsonEditorValue = JSON.parse(JSON.stringify(row.meta));

    this.selectedServiceTypeSms = [... new Set(row.vendorSmsServices.map(p => p.serviceTypeSms.id))];
    this.servicesRegions = Enumerable.from(row.vendorSmsServices as any[])
      .groupBy(p => p.serviceTypeSms.id)
      .toObject(p => p.key(), p => p.select(i => i.region.name).toArray());

    form.balanceNotify = form.balanceNotify || {
      currency: "HKD",
      threshold: 0,
      enabled: false,
      emails: ""
    };

    this.formState = "edit";
    this.form = form;
    this.clearFormValidations();
    this.formVisible = true;
  }

  public onFormCancel() {
    this.formVisible = false;
  }

  public async onFormConfirm() {
    if (this.formState === "create") {
      // this.onCreateConfirm();
    } else {
      this.onEditConfirm();
    }
  }

  //
  public async onPaginationChange() {
    await this.loadData();
    this.$scrollTo("#data-table");
  }

  public onChangeServiceTypeSms(values) {
    const servicesRegions = {};
    for(const value of values) {
      servicesRegions[value] = this.servicesRegions[value] || [];
    }
    this.servicesRegions = servicesRegions;
  }

  //
  private async init() {
    await this.loadData();
  }

  private async loadData() {
    await Promise.all([
      this.loadVendors(),
      this.loadRegions(),
      this.loadServices(),
    ]);
  }

  private async loadVendors() {
    this.isTableLoading = true;
    const { data } = await apiClient.vendors({
      take: this.pageSize,
      page: this.currentPage
    });
    // this.count = data.count;
    // this.data = data.data;
    this.data = data;
    this.isTableLoading = false;

    this.data = this.data.filter(d => !["aliyun", "cm", "twilio"].includes(d.name));
  }

  private async loadRegions() {
    const { data } = await apiClient.regions();
    this.regions = data;
  }

  private async loadServices() {
    const { data } = await apiClient.services();
    this.services = data;
  }

  // events
  private async onEditConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.putVendors(this.form.id, this.getForm());
      this.formVisible = false;
      updateNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  //
  private getForm() {
    const vendorSmsServices = [];
    for (const [serviceTypeSmsId, regionNames] of Object.entries(this.servicesRegions)) {
      for(const regionName of regionNames as any[]) {
        vendorSmsServices.push({
          serviceTypeSms: this.serviceTypeSmss.find(p => p.id === +serviceTypeSmsId),
          region: this.regions.find(region => region.name === regionName),
        });
      }
    }

    return {
      ... this.form,
      meta: JSON.parse((this.$refs.jsonEditor as any).getValue()),
      vendorSmsServices,
    };
  }

  private clearFormValidations() {
    if (this.$refs.form) {
      (this.$refs.form as any).clearValidate();
    }
  }

  private validateForm() {

  }

}
